import { useCallback, useRef, useState } from 'react'
import { useAuthStore } from '@/common/zustand/store/auth.store'
import { useDdjjMedicoStore } from '@/common/zustand/store/ddjj-medico.store'
import { subirDdjjMedico } from '@/common/utils/services/usuarios.service'
import { MODAL_CARGA_DDJJ } from '../constants/modal-carga-ddjj.js'

// PBI 81147: envío del archivo y efectos sobre el store (D6, D7).
// D8: `contrato` es opcional; sin prop se usa el contrato activo (apertura desde el banner).
export function useCargaDdjj({
  contrato: contratoProp,
  onExito,
  onCargada,
  mensajeError = MODAL_CARGA_DDJJ.errorGenerico,
  mensajeSesionVencida = MODAL_CARGA_DDJJ.sesionVencida,
  mensajeExito = MODAL_CARGA_DDJJ.exito,
} = {}) {
  const contratoActivo = useAuthStore((state) => state.contrato)
  const contrato = contratoProp ?? contratoActivo
  const marcarSubida = useDdjjMedicoStore((state) => state.marcarSubida)
  const refrescar = useDdjjMedicoStore((state) => state.refrescar)
  const mostrarAviso = useDdjjMedicoStore((state) => state.mostrarAviso)
  const [enviando, setEnviando] = useState(false)
  const [error, setError] = useState(null)
  const controllerRef = useRef(null)

  const enviar = useCallback(
    async (archivo) => {
      setError(null)
      setEnviando(true)
      controllerRef.current = new AbortController()

      const res = await subirDdjjMedico({ contrato: Number(contrato), archivo, signal: controllerRef.current.signal })
      controllerRef.current = null
      setEnviando(false)

      if (res.cancelado) return
      if (res.code === 201) {
        onExito()
        marcarSubida(contrato, res.data?.ddjjPendiente)
        mostrarAviso(mensajeExito)
        onCargada?.(contrato)
        return
      }
      if (res.code === 409) {
        onExito()
        refrescar()
        onCargada?.(contrato)
        return
      }
      // D9: con la sesión vencida se muestra el mensaje propio en lugar del genérico.
      if (res.code === 401 && mensajeSesionVencida) {
        setError(mensajeSesionVencida)
        return
      }
      setError(res.message || mensajeError)
    },
    [
      contrato,
      marcarSubida,
      refrescar,
      mostrarAviso,
      onExito,
      onCargada,
      mensajeError,
      mensajeSesionVencida,
      mensajeExito,
    ]
  )

  // D7: cerrar con el envío en curso aborta y re-consulta el estado real.
  const abortar = useCallback(() => {
    if (!controllerRef.current) return
    controllerRef.current.abort()
    controllerRef.current = null
    setEnviando(false)
    refrescar()
  }, [refrescar])

  const limpiarError = useCallback(() => setError(null), [])

  return { enviar, abortar, enviando, error, limpiarError }
}
